import script from "./failSuccessList.vue?vue&type=script&lang=jsx&setup=true"
export * from "./failSuccessList.vue?vue&type=script&lang=jsx&setup=true"

import "./failSuccessList.vue?vue&type=style&index=0&id=605b1136&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605b1136"]])

export default __exports__